import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UTMQueryParams {
  utms: {
    utm_campaign: string;
    utm_medium: string;
    utm_source: string;
    origin_source: string;
    origin_medium: string;
    utm_id: string;
  };
}
interface QueryStringState extends UTMQueryParams {
  journeyid: string;
  productid: string;
  flowType: string;
  additionalserviceid: string;
  returnurl: string;
  coupon: string;
  scheduleLandingPage?: string | null;
}

const initialState: QueryStringState = {
  journeyid: '',
  productid: '',
  flowType: '',
  additionalserviceid: '',
  returnurl: '',
  coupon: '',
  utms: {
    utm_campaign: '',
    utm_medium: '',
    utm_source: '',
    utm_id: '',
    origin_source: '',
    origin_medium: ''
  }
};

export const queryStringSlice = createSlice({
  name: 'querystring',
  initialState,
  reducers: {
    saveQueryString: (state, action: PayloadAction<Partial<QueryStringState>>) => {
      return (state = { ...state, ...action.payload });
    },
    createScheduleLandingPage: (state, action: PayloadAction<string | null>) => {
      state.scheduleLandingPage = action.payload;
    }
  }
});

export const { saveQueryString, createScheduleLandingPage } = queryStringSlice.actions;
export const queryStringReducer = queryStringSlice.reducer;
